import { render, staticRenderFns } from "./StockDetails.vue?vue&type=template&id=08b795c8&scoped=true"
import script from "./StockDetails.vue?vue&type=script&lang=js"
export * from "./StockDetails.vue?vue&type=script&lang=js"
import style0 from "./StockDetails.vue?vue&type=style&index=0&id=08b795c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b795c8",
  null
  
)

export default component.exports